import appConstants from '~/libs/constants/application-constants.js'
import { useRootStore } from '~/store/root'

const { nuxtBaseUrl } = appConstants

// Rejects an absolute URL, matching params-to-cookies.js's own r-param check.
export function safeRelativeRedirectPath(candidate) {
  const path = Array.isArray(candidate) ? candidate[0] : candidate
  if (!path || typeof path !== 'string') return null

  try {
    new URL(path)
    return null // parsed as an absolute URL -- reject
  } catch {
    return path
  }
}

// Must match the key identity-widget's storeLoginToken() writes to.
const WIDGET_LOGIN_TOKEN_STORAGE_KEY = 'identityWidgetLoginToken'

export function consumeWidgetLoginToken() {
  const token = sessionStorage.getItem(WIDGET_LOGIN_TOKEN_STORAGE_KEY)
  if (token) sessionStorage.removeItem(WIDGET_LOGIN_TOKEN_STORAGE_KEY)
  return token
}

function firstQueryValue(value) {
  return Array.isArray(value) ? value[0] : value
}

export function widgetRedirectOptionsFor(pageName, query = {}) {
  const email = firstQueryValue(query.email) || firstQueryValue(query.e)
  return {
    email: email || undefined,
    view: pageName === 'forgot-password' ? 'forgot-password' : undefined,
  }
}

export function redirectToWidget(returnToPath, options) {
  if (useRootStore().isLoggedIn) {
    return navigateTo(useRootStore().getRedirectUrl())
  }
  return navigateTo(identityWidgetLoginUrl(returnToPath, options), { external: true })
}

// Must match store/identity.js's relayState computed exactly, or SAML SSO login breaks.
const SSO_RETURN_PATH = `${nuxtBaseUrl}/identity/sso`

export function identityWidgetLoginUrl(returnToPath, { email, view } = {}) {
  const { origin } = window.location
  const url = new URL(`${origin}/login`)

  // this app runs under nuxtBaseUrl (/bp); the widget needs it added back in
  url.searchParams.set('return_to', `${origin}${nuxtBaseUrl}${returnToPath || '/resume-app'}`)
  url.searchParams.set('sso_return_path', SSO_RETURN_PATH)
  if (email) url.searchParams.set('email', email)
  if (view) url.searchParams.set('view', view)
  return url.toString()
}
